import GameScreen from "./components/GameScreen";
import "./styles/App.css";
function App() {
  return (
    <div className="App">
      <header>Memorize</header>
      <GameScreen/>
      <footer>Created By Seulchan Han</footer>
    </div>
  );
}

export default App;


